import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../theme/helpers/fontStyle';
import getThemeFromProps from '../../theme/helpers/getThemeFromProps';

export const ButtonContainer = styled('div')`
  & > div:not(:first-child) {
    margin-top: ${spacing(2.5)};
  }
  margin-bottom: ${spacing(2.5)};
`;

export const TimeSlotContainer = styled('div')`
  display: flex;
  justify-content: flex-start;
  background-color: #ffffff;
  padding: ${spacing('lg')} ${spacing('xl')};
  color: ${(props) => getThemeFromProps(props).colors.paragraphTextColor};
`;

export const FormattedTimeContainer = styled('div')`
  margin-left: ${spacing(2.5)};
`;

export const OpeningHourRow = styled('div')`
  display: flex;
  white-space: pre-wrap;
`;

export const OpeningHourColumn = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const $How = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing(3.5)};

  @media ${media.maxWidth.sm} {
    flex-direction: column;
  }
`;

export const $HowTitle = styled.span`
  display: block;
  font-weight: ${fontWeight('bold')};
  ${fontStyle('base')};
  text-align: center;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  margin-bottom: ${spacing('lg')};
`;

export const $HowSubtitle = styled.div`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  margin-bottom: ${spacing('sm')};
`;

export const $HowStep = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 ${spacing(12)};
  flex: 1;
  @media ${media.maxWidth.sm} {
    margin-bottom: ${spacing('xxl')};
  }
`;

export const $HowStepIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${spacing(16)};
  height: ${spacing(16)};
  margin-bottom: ${spacing('sm')};
  svg {
    width: ${spacing(14)};
    height: ${spacing(14)};
  }
`;

export const $HowStepText = styled.div<{ $number?: number }>`
  display: flex;
  align-items: center;

  &:before {
    content: '${({ $number }) => $number}';
    flex-shrink: 0;
    margin-right: ${spacing(3)};
    font-weight: ${fontWeight('light')};
    ${fontStyle('3xl')};
    color: ${({ theme }) => theme.systemColors.defaultTextColor};
  }

  @media ${media.maxWidth.sm} {
    min-width: 250px;
  }
`;

export const $HowStepTextContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const $HowStepTitle = styled.div`
  font-weight: ${fontWeight('bold')};
  ${fontStyle('sm')};
  text-transform: uppercase;
  margin-bottom: ${spacing('xxs')};
  text-align: center;

  color: ${({ theme }) => theme.colors.primary};
`;

export const $HowStepSubtitle = styled.div`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;

  color: ${({ theme }) => theme.systemColors.defaultTextColor};
`;

export const $Line = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${spacing(14)};
  min-width: 700px;
  &:first-child {
    margin-top: 0;
  }
  @media ${media.maxWidth.sm} {
    flex-direction: column;
    min-width: unset;
  }
`;

export const $Documents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  width: 100%;

  ${ButtonContainer} {
    width: 100%;
  }
`;

export const $InfoHandling = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin-left: ${spacing('xxl')};

  &:first-child {
    margin-left: 0;
  }
  @media ${media.maxWidth.sm} {
    margin-top: ${spacing('xxl')};
    margin-left: unset;
  }
`;

export const $InfoHandlingCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: ${spacing('lg')};
  width: 100%;

  background: #ffffff;
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  color: ${({ theme }) => theme.systemColors.defaultTextColor};

  & svg {
    margin-bottom: ${spacing('sm')};
  }

  & div:first-child {
    margin-bottom: ${spacing('sm')};
  }

  *:last-child {
    color: #8a94a6;
    margin-top: ${spacing('sm')};
  }
`;
